import React, { useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Layout from './components/layout/Layout';
import HeroSection from './components/sections/HeroSection';
import AboutSection from './components/sections/AboutSection';
import ProductsSection from './components/sections/ProductsSection';
import TradingSection from './components/sections/TradingSection';
import InsightsSection from './components/sections/InsightsSection';
import TradingContactSection from './components/sections/TradingContactSection';
import './App.css';

gsap.registerPlugin(ScrollTrigger);

function TradingPage() {
  useEffect(() => {
    // Initialize any global animations or effects
    const sections = document.querySelectorAll('section');
    
    sections.forEach(section => {
      ScrollTrigger.create({
        trigger: section,
        start: 'top 80%',
        end: 'bottom 20%',
        toggleClass: { targets: section, className: 'active' }
      });
    });

    return () => {
      // Clean up ScrollTrigger when component unmounts
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  }, []);

  return (
    <Layout>
      <HeroSection />
      <AboutSection />
      <ProductsSection />
      <TradingSection />
      <InsightsSection />
      <TradingContactSection />
    </Layout>
  );
}

export default TradingPage;